export function applyChitPostingRowTransforms(
  list,
  postingTypes,
  feeearnerdata,
  checkedList,
) {
  if (!list?.data) return;
  list.data.forEach((item) => {
    item.select = false;
    item.postingField = postingTypes?.filter(
      (item1) => item.postingType === item1.code,
    )[0];
    item.postingType = item.postingField;
    if (
      item?.postingField?.code === "DCR" ||
      item?.postingField?.code === "DDR"
    ) {
      item.ddaBank = item.nominalInfo;
    }
    if (
      item?.postingField?.code === "CCR" ||
      item?.postingField?.code === "CDR"
    ) {
      item.clientBank = item.nominalInfo;
    }
    if (
      item?.postingField?.code === "OCR" ||
      item?.postingField?.code === "ODR" ||
      item?.postingField?.code === "DPU"
    ) {
      item.officeBank = item.nominalInfo;
    }

    item.feeEarnerRefOriginal = item.feeEarnerRef;

    item.feeearner = feeearnerdata?.filter(
      (item1) => item.feeEarnerRef === item1.userRef,
    )[0];
    item.feeEarnerRef = item.feeearner;
    checkedList.forEach((item1) => {
      if (item.chitId === item1) {
        item.select = true;
      }
    });
  });
}
